// extracted by mini-css-extract-plugin
export default {"info":"Welcome_info__4rGGg","contentContainer":"Welcome_contentContainer__gHgSA","welcomeText":"Welcome_welcomeText__vbx4M"};